jQuery(document).ready(function($) {

    $(".team_item").click(function(){
        $(this).toggleClass("active");
    });
  
  // Review Slider
  if($('#cb_hero_slider').length) {
      var elements = $('#cb_hero_slider .carousel-cell');
      
      if (elements.length === 1) {
          var flkty = new Flickity('#cb_hero_slider', {
            "autoPlay": false,
            "prevNextButtons": false,
            "pageDots": false,
            "draggable": true,
            "cellAlign": "center",
            "selectedAttraction": 0.015,
            "friction": 0.25,
            wrapAround: true 
        });
      }else {
          var flkty = new Flickity('#cb_hero_slider', {
            "autoPlay": false,
            "prevNextButtons": true,
            "pageDots": true,
            "draggable": true,
            "cellAlign": "center",
            "selectedAttraction": 0.015,
            "friction": 0.25,
            wrapAround: true 
        });
      }
  }

  if($('#image_carousel').length) {
      var flkty = new Flickity('#image_carousel', {
          "autoPlay": false,
          "prevNextButtons": true,
          "pageDots": true,
          "draggable": true,
          "contain": true,
          "cellAlign": "center",
          "selectedAttraction": 0.015,
          "friction": 0.25,
          wrapAround: true 
      });
  }

  if($('.team_silder').length) {
      var flkty = new Flickity('.team_silder', {
          "autoPlay": false,
          "prevNextButtons": true,
          "pageDots": true,
          "draggable": true,
          "cellAlign": "left",
          "selectedAttraction": 0.015,
          "friction": 0.25,
          wrapAround: true 
      });

    $(".team_title").prepend($(".team_silder .flickity-prev-next-button.previous"));
    $(".team_title").append($(".team_silder .flickity-prev-next-button.next"));
  }

  if($('.it_scroll_grid_slider').length) {
      var flkty = new Flickity('.it_scroll_grid_slider', {
          "autoPlay": false,
          "prevNextButtons": false,
          "pageDots": true,
          "draggable": true,
          "contain": true,
        "adaptiveHeight": true,
          "cellAlign": "center",
          "selectedAttraction": 0.015,
          "friction": 0.25,
        wrapAround: true 
      });
  }

  if($('.column_grid_slider').length) {
      var flkty = new Flickity('.column_grid_slider', {
          "autoPlay": false,
          "prevNextButtons": true,
          "pageDots": true,
          "draggable": true,
          "contain": true,
          "cellAlign": "center",
          "selectedAttraction": 0.015,
          "friction": 0.25,
        wrapAround: true 
      });
  }

  /*
  /// accordion
  */

  if ($('.accordion').length > 0) {
      $('.accordion_content').hide();
      $('.accordion_item:first-child .accordion_content').show();

      $('.accordion_item:first-child').addClass('open');

      $('.accordion_title').click(function() {
          var $accordionItem = $(this).closest('.accordion_item');
          $accordionItem.siblings().removeClass('open').find('.accordion_content').slideUp();
          $accordionItem.addClass('open').find('.accordion_content').slideDown();
      });
  }


  /*
  /// Contact Product
  */

  if ($('.contact').length > 0) {
      var contactElement = $('.contact');
      var mainElement = $('#ProductInfo-template--20761770819909__main');
    
      mainElement.append(contactElement);
  }
  
});